import React, { useEffect, useState, Fragment } from "react";
import Loading from "../../../Common/Components/Loading";
import { GetData } from "./Components/Services";
import { Helmet } from "react-helmet";
import DataTable from "../../../Common/Components/DataTable";
import { useNavigate } from "react-router-dom";

export default function List() {
  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
  };
  const navigate = useNavigate();
  const [state, setState] = useState(initialState);
  const [filter, setfilter] = useState({});

  const hanlder = (pageNumber = 1, limit, fliter) => {
    setState({ ...state, loading: true });
    GetData(pageNumber, limit, fliter).then(response => {
      setState({
        loading: false,
        data: response,
      });
    });
  };
  useEffect(() => {
    hanlder();
  }, []);
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست درخواست ها</title>
      </Helmet>

      <DataTable
        loading={state.loading}
        heads={[
          {
            title: "نام کاربر",
            key: "usertiketer",
            keyName: "fullname",
          },
          {
            title: "َشماره کاربر",
            key: "usertiketer",
            keyName: "mobile",
          },
          {
            title: "نوع کاربر",
            key: "role",
            type: "enum",
            enum: {
              user: "کاربر",
              manager: "مدیر مجموعه",
              classmanager: "برگزار کننده کلاس",
            },
          },
          {
            title: "عنوان درخواست",
            key: "title",
          },
          {
            title: "وضعیت درخواست",
            key: "status",
            type: "enum",
            enum: {
              answerd: "پاسخ داده شده",
              waiting: "در حال انتظار",
            },
          },

          {
            title: "تاریخ ایجاد",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },

          {
            title: "تاریخ ایجاد",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty=" درخواستی  ثبت نشده"
        list={state.data && state.data.data}
        data={state.data}
        currentPage={state.data && state.data.current_page}
        function={hanlder}
        header=" لیست درخواست ها"
        links={[
          {
            size: "col-md-12",
            typeLink: "div",
            html: (
              <div className="row">
                <div className="col-md-4">
                  <select
                    onChange={e => {
                      hanlder(null, null, {
                        ...filter,
                        departman: e.target.value,
                      });
                    }}
                    className="form-control"
                  >
                    <option value="">نوع دپارتمان</option>
                    <Fragment>
                      <option value="">مشاهده همه</option>
                      <option value="financial">مالی</option>
                      <option value="technical">فنی</option>
                      <option value="reservation"> رزرو</option>
                      <option value="complaints">شکایات</option>
                    </Fragment>
                  </select>
                </div>
                <div className="col-md-4">
                  <select
                    className="form-control "
                    onChange={e => {
                      hanlder(null, null, {
                        ...filter,
                        status: e.target.value,
                      });
                    }}
                  >
                    <option value={""}> وضعیت</option>
                    <Fragment>
                      <option value={""}>مشاهده همه</option>
                      <option value={"waiting"}>درانتظار</option>
                      <option value={"answerd"}>پاسخ داده شده</option>
                      <option value={"closed"}>بسته شده</option>
                    </Fragment>
                  </select>
                </div>
                <div className="col-md-4">
                  <select
                    className="form-control"
                    onChange={e => {
                      hanlder(null, null, {
                        ...filter,
                        user_role: e.target.value,
                      });
                    }}
                  >
                    <option value={""}> نقش کاربر</option>
                    <Fragment>
                      <option value={""}>مشاهده همه</option>
                      <option value={"user"}>کاربر</option>
                      <option value={"manage"}> مدیر</option>
                      <option value={"coach"}> مربی</option>
                    </Fragment>
                  </select>
                </div>
              </div>
            ),
          },

          {
            function: selected => {
              navigate(
                `/Admin/ticketing/chat/${
                  state.data &&
                  state.data.data.filter(item => item.id == selected)[0].id
                }`,
                {
                  state: {
                    data:
                      state &&
                      state.data &&
                      state.data.data.filter(item => item.id == selected)[0],
                  },
                }
              );
            },
            color: "success",
            size: "col-md-2",
            html: "مشاهده",
            multi: false,
            main: true,
            type: "show",
          },
        ]}
      />
    </Fragment>
  );
}
